export const PersonalComList = [
  'field-user-name',
  'field-sex',
  'field-exam-no',
  'field-card-type',
  'field-birthday',
  'field-id-number',
  'field-group-schedule',
  'field-contest-time',
  'field-phone',
  'field-certificate-get',
  'field-certificate-post-address',
];

export const SchoolComList = [
  'field-school-area',
  'field-school-name',
  'field-teacher-name',
  'field-grade',
  'field-class-name',
];
